export class EcsFilter {
    id: string;
    nomeFantasia: string;
    codEstabelecimento: string;
    idAdquirente: string;
    acao: string;
    documento: string;
    ecInativos : boolean;
    bandeira :  string;
}